import React from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";

// components
import Layout from "./Layout";
import Layoutold from "./Layoutold"; 

// pages
import Error from "../pages/error";
import Login from "../pages/login";

import MainPage from "../pages";
import Inviz from "../pages/inviz";
import NotFoundPage from "../pages/404";
import LoginPage from "../pages/login";
import SignUpPage from "../pages/signup-new";
import VerifyPage from "../pages/verify";
import GmxPage from "../pages/gmx";
import Blockproducers from "../pages/blockproducers";
import Blockproducersmain from "../pages/blockproducersmain";
import Blockproducersmainhome2 from "../pages/blockproducersmainHome2";
import Blockproducersmainhome3 from "../pages/blockproducersmainHome3";
import Blockproducersmainhome4 from "../pages/blockproducersmainHome4";
import Blockproducersprivacy from "../pages/blockproducersprivacy";
import Blockproducersterms from "../pages/blockproducersterms";
import Blockproducersabout from "../pages/blockproducersabout";
import Blockproducerscontact from "../pages/blockproducerscontact";
import InterblockchainM from "../pages/interblockchain";
import InterblockchainSignup from "../pages/signup-blockproducers";
import InterestBlock from "../pages/interest";
import CompanyPage from "../pages/company";
import ProAboutPage from "../pages/proabout";
import SigninPage from "../pages/signin";
import AboutusPage from "../pages/aboutus"; 
import SolutionsPage from "../pages/solutions";
import SignalsPage from "../pages/signals";
import CareersPage from "../pages/careers";
import PrivacyPage from "../pages/privacynew";
import ChartPageLine from "../pages/chartline";
import ChartPageLine2 from "../pages/chartline2";
import Upsignaldashboard from "../pages/upsignaldashboard";
import BPrivacy from "../pages/bprivacy";
import TermsPage from "../pages/bterms";
import Quote from "../pages/quote";
import Providers from "../pages/providers";
// context
import { useUserState } from "../context/UserContext";

export default function App() {
  // global
  var { isAuthenticated } = useUserState();

  return (
    <Router>
      <Switch>
         <Route exact path="/" component={MainPage}></Route>
           <Route exact path="/404"  component={NotFoundPage}></Route>
         <Route exact path="/careers"  component={CareersPage}></Route>
         <Route exact path="/signals"  component={SignalsPage}></Route>
          <Route exact path="/company"  component={CompanyPage}></Route>
           <Route exact path="/privacy"  component={PrivacyPage}></Route>
            <Route exact path="/terms"  component={TermsPage}></Route>
            <Route exact path="/quote"  component={Quote}></Route>
            <Route exact path="/about"  component={AboutusPage}></Route>
             <Route exact path="/providers"  component={Providers}></Route>
         <Route component={Error} />
      </Switch>
    </Router>
  );

  // #######################################################################

  function PrivateRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/trial",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    );
  }
}
